// @flow

/*::
declare var __webpack_require__: mixed;
*/

module.exports = typeof __webpack_require__ !== "undefined";



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-webpack-bundle/index.js
// module id = ./node_modules/is-webpack-bundle/index.js
// module chunks = 40